module.exports = __webpack_public_path__ + "static/media/gastronomy-tours.a37e2f1b.png";